'use strict';

var variables = require('./variables-1eb6495a.js');

// Not typed as still in lab
const light = {
    root: {
        height: 32,
        lineHeight: 16,
        width: 32,
        fontSize: variables.SIZES.TEXT_MEDIUM,
        borderRadius: variables.SIZES.BORDER_RADIUS,
        padding: "7px 16px",
        border: `1px solid ${variables.COLORS.GREYSCALE_0_15}`,
        backgroundColor: variables.COLORS.GREYSCALE_100_60,
        color: variables.COLORS.GREYSCALE_25,
        zIndex: 1,
        "&:active": {
            backgroundColor: variables.COLORS.GREYSCALE_0_10,
            border: `1px solid ${variables.COLORS.GREYSCALE_0_30}`,
        },
        "&:hover": {
            backgroundColor: variables.COLORS.GREYSCALE_0_03,
            border: `1px solid ${variables.COLORS.GREYSCALE_0_30}`,
        },
        "&.sprout-focus-visible": {
            backgroundColor: variables.COLORS.GREYSCALE_0_03,
            boxShadow: `0 0 0 1px ${variables.COLORS.MISC_FOCUS_BORDER}`,
            border: `1px solid ${variables.COLORS.MISC_FOCUS_BORDER}`,
            zIndex: 2,
        },
        "&$selected": {
            color: variables.COLORS.GREYSCALE_25,
            backgroundColor: variables.COLORS.GREYSCALE_0_10,
            zIndex: 2,
            "&:hover": {
                backgroundColor: variables.COLORS.GREYSCALE_0_10,
                border: `1px solid ${variables.COLORS.GREYSCALE_0_15}`,
            },
        },
    },
    sizeSmall: {
        fontSize: variables.SIZES.TEXT_SMALL,
        height: 24,
        width: 24,
        padding: 7,
    },
    sizeLarge: {
        fontSize: variables.SIZES.TEXT_LARGE,
        height: 40,
        width: 40,
        lineHeight: 20,
    },
};

var MuiToggleButton = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiToggleButton = MuiToggleButton;
exports.light = light;
